<template>
  <div class="box">
    <MainHalfTitle text="中大網上認知測試"></MainHalfTitle>
    <div class="row">
      <div class="item">機構名稱：</div>
      <div class="value">{{data.organization_name}}</div>
    </div>
    <div class="row">
      <div class="item">機構編號：</div>
      <div class="value">{{data.organization_number}}</div>
    </div>
    <div class="row">
      <div class="item">職員名稱：</div>
      <div class="value">{{data.name}}</div>
    </div>
    <div class="row">
      <div class="item">職員編號：</div>
      <div class="value">{{data.number}}</div>
    </div>
  </div>
</template>

<script>
import MainHalfTitle from "@/components/common/MainHalfTitle";

export default {
  name: "HomeStaffInfo",
  components: {MainHalfTitle},
  props: {
    data: {type: Object}
  }
}
</script>

<style scoped>
.box{
  text-align: center;
}
.row{
  display: flex;
  align-items: start;
  text-align: left;
  font-size: var(--ecs-font-md);
  padding: clamp(0.5rem, 1vw, 0.75rem);
  line-height: 1.3;
}
.item{
  display: inline-block;
  width: var(--ecs-label-width);
  text-align: right;
  margin-right: clamp(0.75rem, 2vw, 1.5rem);
}
.value{
  display: inline-block;
  width: var(--ecs-control-width-sm);
  max-width: 90vw;
}

@media (orientation: landscape) and (max-height: 480px) {
  .row {
    padding: clamp(0.25rem, 0.5vw, 0.375rem);
  }

  .item {
    margin-right: clamp(0.375rem, 1vw, 0.75rem);
  }
}
</style>
